import { render } from "./ReferencesListPopup.vue?vue&type=template&id=85f8022a&scoped=true"
import script from "./ReferencesListPopup.vue?vue&type=script&lang=js"
export * from "./ReferencesListPopup.vue?vue&type=script&lang=js"

import "./ReferencesListPopup.vue?vue&type=style&index=0&id=85f8022a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f8022a"]])

export default __exports__